//#region src/heartland_gateway.ts
let HeartlandGateway = /* @__PURE__ */ function(HeartlandGateway) {
	HeartlandGateway["Portico"] = "portico";
	HeartlandGateway["TransIT"] = "transit";
	return HeartlandGateway;
}({});
//#endregion
export { HeartlandGateway };

//# sourceMappingURL=heartland_gateway.js.map